<template>
  <div class="reviewer-group setting-section">
    <div class="setting-title m-b-22 flex row-between">
      <span>组建评审小组</span>

      <div>
        <el-button :disabled="!beforeStart" @click="syncReviewer">
          专家抽取
        </el-button>
        <el-button :disabled="!beforeStart" @click="openHistoryProjectDialog">
          项目导入
        </el-button>
        <el-button :disabled="!beforeStart" @click="addReviewerManually">
          手动添加
        </el-button>
        <el-button v-if="beforeStart" type="primary" @click="openReview">
          开始评标
        </el-button>
        <el-button class="m-l-16" size="small" @click="toggleTableVisible">
          {{ tableVisible ? '隐藏' : '展开' }}
          <i
            :class="tableVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          ></i>
        </el-button>
      </div>
    </div>

    <jczh-table-content
      v-show="tableVisible"
      :data="list"
      :option="tableOptions"
      pagination
      :total="total"
      :page.sync="page"
      :limit.sync="size"
      @pagination="getTableData"
    >
      <template v-slot:last>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openReviewerDetail(row)">
              查看详情
            </el-button>
            <!-- 开启评标后，禁用该功能 -->
            <template v-if="beforeStart">
              <el-button type="text" @click="resetExpertPassword(row)">
                重置密码
              </el-button>
              <el-button
                type="text"
                class="text-danger"
                @click="removeExpert(row)"
              >
                移除
              </el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </jczh-table-content>

    <el-button
      v-if="beforeStart && total > 0"
      class="m-t-16 reset-btn"
      plain
      @click="resetPrint"
    >
      一键重置密码打印
    </el-button>

    <online-review-history-dialog
      ref="reviewHistoryDialogRef"
      @afterImport="getTableData"
    />

    <add-expert-manually-dialog
      ref="manuallyDialogRef"
      :visible.sync="manuallyDialogVisible"
      :on-add-expert="provideSetUpReviewerManually"
    />

    <!-- 评委信息 -->
    <online-reviewer-info-dialog ref="reviewerInfoDialogRef" />
  </div>
</template>

<script>
import OnlineReviewHistoryDialog from '@/components/online-review/project/OnlineReviewHistoryDialog.vue'
import AddExpertManuallyDialog from '@/views/procure-views/purchase/invite-bid/components/AddExpertManuallyDialog.vue'
import OnlineReviewerInfoDialog from '@/components/online-review/project/OnlineReviewerInfoDialog.vue'
import { whetherDict } from '@/dictionary/project/common'

/**
 * 规范评审组建评审小组，专家成员独立评审时使用
 */
export default {
  name: 'OnlineReviewerStandard',

  components: {
    AddExpertManuallyDialog,
    OnlineReviewHistoryDialog,
    OnlineReviewerInfoDialog
  },

  props: {
    list: {
      type: Array,
      default: () => []
    }
  },

  inject: [
    'provideReviewId',
    'provideOrderId',
    'providePurchaseType',
    'provideSyncReviewer',
    'provideResetPrint',
    'provideResetExpertPassword',
    'provideRemoveExpert',
    'provideSetUpReviewerManually',
    'provideBeforeStart',
    'provideReviewClosed'
  ],

  data() {
    return {
      // 控制专家列表的显示和隐藏
      tableVisible: false,

      page: 1,
      size: 10,
      total: 0,
      tableOptions: [
        { label: '专家姓名', prop: 'expertName' },
        { label: '联系电话', prop: 'expertMobile' },
        // { label: '所在单位', prop: 'companyName' },
        {
          label: '是否为招标人评委',
          prop: 'isPurchaseExpert',
          filter: value => whetherDict.translate(value).label || '-'
        }
      ],

      // 手动添加评委弹窗显示控制
      manuallyDialogVisible: false
    }
  },

  computed: {
    reviewId() {
      return this.provideReviewId()
    },

    orderId() {
      return this.provideOrderId()
    },

    purchaseType() {
      return this.providePurchaseType()
    },

    beforeStart() {
      return this.provideBeforeStart()
    },

    reviewEnd() {
      return this.provideReviewClosed()
    }
  },

  watch: {
    beforeStart: {
      handler(val) {
        if (val) {
          this.tableVisible = true
        }
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 展开或收起专家列表
     */
    toggleTableVisible() {
      this.tableVisible = !this.tableVisible
    },

    getTableData() {
      this.$emit('reloadReview')
    },

    /**
     * 重置当前专家密码
     */
    resetExpertPassword(row) {
      this.provideResetExpertPassword(row)
    },

    /**
     * 移除专家
     */
    removeExpert(row) {
      this.provideRemoveExpert(row)
    },

    openReviewerDetail(row) {
      this.$refs.reviewerInfoDialogRef.openDialog(row)
    },

    resetPrint() {
      this.provideResetPrint()
    },

    /**
     * 同步专家抽取结果
     */
    syncReviewer() {
      this.provideSyncReviewer()
    },

    /**
     * 打开历史评审项目，从中导入评委列表
     */
    openHistoryProjectDialog() {
      this.$refs.reviewHistoryDialogRef.openDialog()
    },

    /**
     * 打开手动添加评委弹窗
     */
    addReviewerManually() {
      this.manuallyDialogVisible = true
    },

    openReview() {
      this.$emit('openReview')
    }
  }
}
</script>

<style scoped lang="scss">
.setting-section {
  .setting-title {
    font-size: 16px;
    color: $text-color;
  }
}
</style>
